import { Input } from "@/src/components/universalInput";
import { TemporaryLeave } from "@/src/data/allTypes";
import React from "react";

export function TemporaryLeaveForm({
  temporaryLeave,
  onChange,
}: {
  temporaryLeave: TemporaryLeave;
  onChange?: (newValue: TemporaryLeave) => void;
}) {
  const [current, setCurrent] = React.useState(temporaryLeave);
  function onLocalChange(newValue: TemporaryLeave) {
    setCurrent(newValue);
    onChange?.(newValue);
  }
  return (
    <div className="c1 gap10">
      <Input
        type="date"
        name={"Date de sortie"}
        value={current.exitDate}
        onChange={(newValue) => {
          onLocalChange({ ...current, exitDate: newValue });
        }}
      ></Input>
      <Input
        type="date"
        name={"Date de retour"}
        value={current.returnDate}
        onChange={(newValue) => {
          onLocalChange({ ...current, returnDate: newValue });
        }}
      ></Input>
      <Input
        type="textarea"
        name={"Notes"}
        value={current.notes}
        onChange={(newValue) => {
          onLocalChange({ ...current, notes: newValue });
        }}
      ></Input>
    </div>
  );
}
